module.exports = __webpack_public_path__ + "static/media/ertec.7fe7081a.svg";